import { Pin as PinPresenter } from './presenter';
export var Pin = PinPresenter;
export default Pin;